import { ChangeDetectionStrategy, Component, computed, effect, Signal, signal, untracked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TradeClassMultiSelectComponent } from '../../../trade-class';
import { ReportParameterBase } from './report-parameter-base';

@Component({
    selector: 'app-trade-class-multi-select-parameter',
    imports: [TradeClassMultiSelectComponent],
    template: `
        <app-trade-class-multi-select
            [selectedTradeClassKeys]="tradeClassKeys()"
            [id]="parameterKey()"
            [subscriberKey]="subscriberKey()"
            [placeHolder]="subscriberKey() != null ? parameterDefinition().placeholder : 'Select a subscriber first'"
            [invalid]="isInvalid()"
            [disabled]="isDisabled()"
            (blur)="onBlur()"
            (loadingChange)="onLoadingChange($event)"
            (selectedTradeClassKeysChange)="onSelectedTradeClassKeysChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TradeClassMultiSelectParameterComponent,
            multi: true
        }
    ]
})
export class TradeClassMultiSelectParameterComponent extends ReportParameterBase<number[]> {
    tradeClassKeys = signal<number[]>([]);
    subscriberKey: Signal<number | null> = this.reportWorkspace.subscriberKey;

    override isDisabled = computed(() => this.reportWorkspace.isReportRunning() || this.isFormControlDisabled() || !this.subscriberKey());

    constructor() {
        super();

        /* Clear Options when Subscriber Changes */
        effect(() => {
            this.subscriberKey();
            const parameterDefinition = (untracked(this.parameterDefinition));

            if (!this.isInitialized) {
                return;
            }

            const value = (parameterDefinition.emptyValue as number[]) ?? [];

            this.tradeClassKeys.set(value);
            this.reportWorkspace.setParam(parameterDefinition.key, value);
            this.onChange(value);

            this.formControl?.markAsUntouched();
            this.formControl?.markAsPristine();
        });
    }

    onSelectedTradeClassKeysChange(tradeClassKeys: number[]) {
        this.tradeClassKeys.set(tradeClassKeys);

        this.reportWorkspace.setParam(this.parameterDefinition().key, tradeClassKeys);

        this.onChange(tradeClassKeys);
        this.markTouchedIfNotResetting();
    }

    onLoadingChange(isLoading: boolean) {
        this.reportWorkspace.setParamLoading(this.parameterDefinition().key, isLoading);
    }

    onBlur() {
        this.onTouched();
    }

    // CVA callbacks
    writeValue(obj: number[]): void {
        this.tradeClassKeys.set(obj ?? []);
    }
}
